module.exports = __webpack_public_path__ + "img/administracion-publica.b5519036.jpg";